import { createSlice } from '@reduxjs/toolkit';
import { fetchClientsThunk, ClientListItem } from './thunks/fetch-clients-thunk';

export interface ClientsState {
  list: ClientListItem[];
  isLoading: boolean;
  error: string | null;
  lastFetchedAt: string | null;
}

const initialState: ClientsState = {
  list: [],
  isLoading: false,
  error: null,
  lastFetchedAt: null
};

const clientsSlice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    // Reset clients list state
    resetClients: (state) => {
      state.list = [];
      state.error = null;
      state.lastFetchedAt = null;
    }
  },
  extraReducers: (builder) => {
    // Fetch clients list
    builder
      .addCase(fetchClientsThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchClientsThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
        state.error = null;
        state.lastFetchedAt = new Date().toISOString();
      })
      .addCase(fetchClientsThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || 'Failed to fetch clients';
      });
  }
});

export const { resetClients } = clientsSlice.actions;
export default clientsSlice.reducer;
